import { createSlice, current } from "@reduxjs/toolkit";

const reducerSlice = createSlice({
  name: "balance",
  initialState: {
    list: [],
    data: {},
    popup: false,
    startDateFilter: "",
    endDateFilter: "",
    inquiry: {},
    canWithdraw: {},
    modalBalance: false,
    invoiceDetail: {},
    loading: false,
    hasMoreItems: true,
    currentPage: 0,
  },
  reducers: {
    setList: (state, action) => {
      state.list = action.payload;
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
    setPopup: (state, action) => {
      state.popup = action.payload;
    },
    setStartDateFilter: (state, action) => {
      state.startDateFilter = action.payload;
    },
    setEndDateFilter: (state, action) => {
      state.endDateFilter = action.payload;
    },
    setInquiry: (state, action) => {
      state.inquiry = action.payload;
    },
    setCanWithdraw: (state, action) => {
      state.canWithdraw = action.payload;
    },
    setModalBalance: (state, action) => {
      state.modalBalance = action.payload;
    },
    setInvoiceDetail: (state, action) => {
      state.invoiceDetail = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setHasMoreItems: (state, action) => {
      state.hasMoreItems = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    }
  },
});

export const {
  setList,
  setPopup,
  setData,
  setStartDateFilter,
  setEndDateFilter,
  setInquiry,
  setCanWithdraw,
  setModalBalance,
  setInvoiceDetail,
  setLoading,
  setHasMoreItems,
  setCurrentPage
} = reducerSlice.actions;

export default reducerSlice;
